// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { postRequest } from "../../services/api";

// const Register: React.FC = () => {
//     const [formData, setFormData] = useState({
//         firstname: "",
//         lastname: "",
//         email: "",
//         mobile: "",
//         password: "",
//     });
//     const [errors, setErrors] = useState<{ [key: string]: string }>({});
//     const [msgInfo, setMsgInfo] = useState<string | null>(null);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     const validate = () => {
//         let newErrors: { [key: string]: string } = {};

//         if (!formData.firstname.trim()) {
//             newErrors.firstname = "First name is required";
//         }
//         if (!formData.lastname.trim()) {
//             newErrors.lastname = "Last name is required";
//         }
//         if (!formData.email.match(/^[\w-]+@([\w-]+\.)+[\w-]{2,4}$/)) {
//             newErrors.email = "Enter a valid email address";
//         }
//         if (!formData.mobile.match(/^[6-9]\d{9}$/)) {
//             newErrors.mobile = "Enter a valid 10-digit mobile number";
//         }
//         if (formData.password.length < 6) {
//             newErrors.password = "Password must be at least 6 characters long";
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();

//         if (!validate()) return;
//         setLoading(true);
//         try {
//             await postRequest("/auth/register", formData);

//             // Step 2: Immediately log them in with same email & password
//             const loginResponse = await postRequest("/auth/login", {
//                 email: formData.email,
//                 password: formData.password,
//             });

//             const { token, user } = loginResponse.data;
//             localStorage.setItem("token", token);
//             localStorage.setItem("user", JSON.stringify(user));

//             setMsgInfo("Registration Successful! Logging you in...");
//             navigate("/dashboard"); // redirect to dashboard
//             window.location.reload();

//             //   setMsgInfo("Registration Successful! Redirecting to login...");
//             //   setTimeout(() => navigate("/login"), 2000); // redirect after 2 sec
//         } catch (err: any) {
//             console.error("Registration failed", err);
//             setMsgInfo("Something went wrong. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="container">
//             <br />
//             <section>
//                 <div className="px-4 py-5 px-md-5 text-center text-lg-start styling">
//                     <div className="container">
//                         <div className="row gx-lg-5 align-items-center">

//                             <div className="col-lg-5 mb-5 mb-lg-0">

//                                 {msgInfo && (
//                                     <div className="alert alert-info">{msgInfo}</div>
//                                 )}

//                                 <div className="card" style={{ boxShadow: "10px 10px 10px lightgrey" }}>
//                                     <div className="card-body py-5 px-md-5">

//                                         <form onSubmit={handleSubmit}>
//                                             <div className="form-outline mb-3">
//                                                 <input
//                                                     type="text"
//                                                     name="firstname"
//                                                     className="form-control"
//                                                     placeholder="First Name"
//                                                     value={formData.firstname}
//                                                     onChange={handleChange}
//                                                     required
//                                                 />
//                                                 {errors.firstname && <small className="text-danger">{errors.firstname}</small>}
//                                             </div>

//                                             <div className="form-outline mb-3">
//                                                 <input
//                                                     type="text"
//                                                     name="lastname"
//                                                     className="form-control"
//                                                     placeholder="Last Name"
//                                                     value={formData.lastname}
//                                                     onChange={handleChange}
//                                                     required
//                                                 />
//                                                 {errors.lastname && <small className="text-danger">{errors.lastname}</small>}
//                                             </div>

//                                             <div className="form-outline mb-3">
//                                                 <input
//                                                     type="email"
//                                                     name="email"
//                                                     className="form-control"
//                                                     placeholder="Email"
//                                                     value={formData.email}
//                                                     onChange={handleChange}
//                                                     required
//                                                 />
//                                                 {errors.email && <small className="text-danger">{errors.email}</small>}
//                                             </div>

//                                             <div className="form-outline mb-3">
//                                                 <input
//                                                     type="text"
//                                                     name="mobile"
//                                                     className="form-control"
//                                                     placeholder="Mobile (10 digits)"
//                                                     value={formData.mobile}
//                                                     onChange={handleChange}
//                                                     required
//                                                 />
//                                                 {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
//                                             </div>

//                                             <div className="form-outline mb-3">
//                                                 <input
//                                                     type="password"
//                                                     name="password"
//                                                     className="form-control"
//                                                     placeholder="Password"
//                                                     value={formData.password}
//                                                     onChange={handleChange}
//                                                     required
//                                                 />
//                                                 {errors.password && <small className="text-danger">{errors.password}</small>}
//                                             </div>

//                                             <button type="submit" className="btn btn-success btn-block mb-4" disabled={loading}>
//                                                 {loading ? "Please wait..." : "Register"}
//                                             </button>

//                                             <p className="mt-3">Already have an account?
//                                                 <Link to="/login" className="link-info ms-1">Login here</Link>
//                                             </p>
//                                         </form>

//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-lg-7 mb-5 mb-lg-0">
//                                 <h2 className="my-5 display-3 fw-bold ls-tight" style={{ fontSize: "3.5rem" }}>
//                                     Create your <br />
//                                     <span className="text-success">Acadebility account</span>
//                                 </h2>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default Register;
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api";
import "../LoginPage/LoginPage.css";
import "./Register.css";

const Register: React.FC = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mobile: "",
    password: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [showPwd, setShowPwd] = useState(false);
  const [msgInfo, setMsgInfo] = useState<string | null>(null);
  const [msgType, setMsgType] = useState<'success' | 'error'>('error');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    const e: { [k: string]: string } = {};
    if (!formData.firstname.trim()) e.firstname = "First name is required";
    if (!formData.lastname.trim())  e.lastname  = "Last name is required";
    //if (!formData.email.match(/^[\w-]+@([\w-]+\.)+[\w-]{2,4}$/)) e.email = "Enter a valid email address";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email)) {
      e.email = "Enter a valid email address";
    }
    if (!formData.mobile.match(/^[6-9]\d{9}$/)) e.mobile = "Enter a valid 10-digit mobile number";
    //if (formData.password.length < 6) e.password = "Password must be at least 6 characters";
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(formData.password)) {
      e.password = "Password must be at least 6 characters and contain letters and numbers";
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setMsgInfo(null);
    try {
      await postRequest("/auth/register", formData);
      const loginRes = await postRequest("/auth/login", { email: formData.email, password: formData.password });
      const { token, user } = loginRes.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      setMsgType('success');
      setMsgInfo("Account created! Logging you in...");
      setTimeout(() => { navigate("/dashboard"); window.location.reload(); }, 800);
    } catch (err: any) {
      setMsgType('error');
      setMsgInfo("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const PERKS = [
    { icon: "🆓", title: "Free to Start",          desc: "Access hundreds of free tests — no card needed" },
    { icon: "📱", title: "Learn Anywhere",           desc: "Mobile-friendly platform, study on the go" },
    { icon: "🔔", title: "Smart Reminders",          desc: "Never miss a study session with alerts" },
    { icon: "🎓", title: "Expert-Curated Content",   desc: "Questions verified by top educators" },
  ];

  return (
    <div className="auth-page">
      {/* ── Left panel ── */}
      <div className="auth-left reg-left">
        <div className="auth-left-inner">
          <Link to="/" className="auth-logo">
            <span className="auth-logo-mark">A</span>
            <span className="auth-logo-text">cadebility</span>
          </Link>

          <div className="auth-headline">
            <h1>Start your journey<br /><span className="auth-accent">for free today.</span></h1>
            <p className="auth-tagline">
              Join over 1 Lakh students already achieving their goals with Acadebility's guided test prep.
            </p>
          </div>

          <div className="auth-features">
            {PERKS.map(p => (
              <div className="auth-feat-item" key={p.title}>
                <span className="auth-feat-icon">{p.icon}</span>
                <div>
                  <div className="auth-feat-title">{p.title}</div>
                  <div className="auth-feat-desc">{p.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="auth-testimonial">
            <p>"I registered in under a minute and started practising immediately. Best decision before my boards!"</p>
            <span>— Priya S., NEET 2024</span>
          </div>
        </div>
        <div className="auth-blob auth-blob-1" />
        <div className="auth-blob auth-blob-2" />
      </div>

      {/* ── Right panel: form ── */}
      <div className="auth-right">
        <div className="auth-form-card reg-card">
          <div className="auth-form-header">
            <h2 className="auth-form-title">Create account</h2>
            <p className="auth-form-sub">It's free and takes less than a minute</p>
          </div>

          {msgInfo && (
            <div className={`auth-alert auth-alert-${msgType}`}>
              {msgType === 'success' ? <span>✅</span> : <span>⚠️</span>}
              {msgInfo}
            </div>
          )}

          <form className="auth-form" onSubmit={handleSubmit}>

            {/* Name row */}
            <div className="reg-name-row">
              <div className="auth-field">
                <label className="auth-label">First name</label>
                <div className="auth-input-wrap">
                  <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input type="text" name="firstname" className={`auth-input${errors.firstname ? " auth-input-err" : ""}`}
                    placeholder="Rohan" value={formData.firstname} onChange={handleChange} required />
                </div>
                {errors.firstname && <span className="auth-err">{errors.firstname}</span>}
              </div>
              <div className="auth-field">
                <label className="auth-label">Last name</label>
                <div className="auth-input-wrap">
                  <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input type="text" name="lastname" className={`auth-input${errors.lastname ? " auth-input-err" : ""}`}
                    placeholder="Kumar" value={formData.lastname} onChange={handleChange} required />
                </div>
                {errors.lastname && <span className="auth-err">{errors.lastname}</span>}
              </div>
            </div>

            {/* Email */}
            <div className="auth-field">
              <label className="auth-label">Email address</label>
              <div className="auth-input-wrap">
                <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
                <input type="email" name="email" className={`auth-input${errors.email ? " auth-input-err" : ""}`}
                  placeholder="you@example.com" value={formData.email} onChange={handleChange} required />
              </div>
              {errors.email && <span className="auth-err">{errors.email}</span>}
            </div>

            {/* Mobile */}
            <div className="auth-field">
              <label className="auth-label">Mobile number</label>
              <div className="auth-input-wrap">
                <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
                </svg>
                <input type="text" name="mobile" className={`auth-input${errors.mobile ? " auth-input-err" : ""}`}
                  placeholder="9876543210" value={formData.mobile} onChange={handleChange} required />
              </div>
              {errors.mobile && <span className="auth-err">{errors.mobile}</span>}
            </div>

            {/* Password */}
            <div className="auth-field">
              <label className="auth-label">Password</label>
              <div className="auth-input-wrap">
                <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <input type={showPwd ? "text" : "password"} name="password"
                  className={`auth-input${errors.password ? " auth-input-err" : ""}`}
                  placeholder="At least 6 characters" value={formData.password} onChange={handleChange} required />
                <button type="button" className="auth-pwd-toggle" onClick={() => setShowPwd(p => !p)} tabIndex={-1}>
                  {showPwd
                    ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                    : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  }
                </button>
              </div>
              {errors.password && <span className="auth-err">{errors.password}</span>}
              {/* Password strength bar */}
              <div className="reg-strength-bar">
                <div className={`reg-strength-fill reg-str-${
                  formData.password.length === 0 ? 'none'
                  : formData.password.length < 4 ? 'weak'
                  : formData.password.length < 8 ? 'fair'
                  : 'strong'
                }`} />
              </div>
            </div>

            <p className="reg-terms">
              By registering you agree to our{" "}
              <Link to="/terms" className="auth-switch-link">Terms of Service</Link>{" "}
              and{" "}
              <Link to="/privacy" className="auth-switch-link">Privacy Policy</Link>.
            </p>

            <button type="submit" className="auth-btn-primary" disabled={loading}>
              {loading
                ? <><span className="auth-spinner" /> Creating account…</>
                : "Create free account →"
              }
            </button>
          </form>

          <p className="auth-switch">
            Already have an account?{" "}
            <Link to="/login" className="auth-switch-link">Sign in here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
